import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export enum KnowledgeBaseQaPairStatus {
  needsReview = 'needs_review',
  active = 'active',
  notUsed = 'not_used',
}

export enum KnowledgeBaseQaPairCategory {
  checkIn = 'check_in',
  checkOut = 'check_out',
  wifi = 'wifi',
  parking = 'parking',
  houseRules = 'house_rules',
  appliances = 'appliances',
  localRecommendations = 'local_recommendations',
  emergency = 'emergency',
  amenities = 'amenities',
  transportation = 'transportation',
  other = 'other',
}

export default class KnowledgeBaseQaPairModel extends Model {
  @attr('string') question!: string;
  @attr('string') answer!: string;
  @attr('string') status!: KnowledgeBaseQaPairStatus;
  @attr('string') category!: KnowledgeBaseQaPairCategory;
  @attr('number') confidenceScore?: number;
  @attr('number') usageCount?: number;
  @attr('date') createdAt!: Date;
  @attr('date') updatedAt!: Date;

  @belongsTo('property', { inverse: null, async: false })
  property?: ModelRegistry['property'];

  get isApproved(): boolean {
    return this.status === KnowledgeBaseQaPairStatus.active;
  }

  get isNotUsed(): boolean {
    return this.status === KnowledgeBaseQaPairStatus.notUsed;
  }

  @belongsTo('ai-knowledge-base-file', { inverse: null, async: false })
  knowledgeBaseFile?: ModelRegistry['ai-knowledge-base-file'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'ai-knowledge-base-qa-pair': KnowledgeBaseQaPairModel;
  }
}
